<template>
  <div class="container">
    <Header></Header>
    <div class="dWrap">
      <div class="content">
        <NewsListTabs
          :tTitle="tTitle"
          :tabsData="tabsData"
          :active="active"
          @changeActive="changeActive"
          @currentChange="currentChange"
          @handleSizeChange="handleSizeChange"
        ></NewsListTabs>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import NewsListTabs from '@/components/NewsListTabs.vue';
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      colData: [
        {
          id: 1,
          colValue: '协会动态'
        },
        {
          id: 2,
          colValue: '通知公告'
        },
        {
          id: 3,
          colValue: '政策法规',
          children: [
            {
              id: 31,
              colValue: '国家'
            },
            {
              id: 32,
              colValue: '广东'
            },
            {
              id: 34,
              colValue: '珠三角地市'
            },
            {
              id: 35,
              colValue: '其他地市'
            }
          ]
        },
        {
          id: 8,
          colValue: '行业资讯',
          children: [
            {
              id: 82,
              colValue: '广东'
            },
            {
              id: 83,
              colValue: '其他地区'
            }
          ]
        },
        {
          id: 4,
          colValue: '会员服务',
          children: [
            {
              id: 43,
              colValue: '会员风采'
            },
            {
              id: 41,
              colValue: '会员服务简介'
            },
            {
              id: 42,
              colValue: '业务指南'
            },
            {
              id: 44,
              colValue: '有问有答'
            },
            {
              id: 45,
              colValue: '专业书刊'
            },
            {
              id: 46,
              colValue: '业务探讨'
            }
          ]
        },
        {
          id: 5,
          colValue: '教育培训',
          children: [
            {
              id: 51,
              colValue: '培训信息'
            },
            {
              id: 52,
              colValue: '微课堂'
            }
          ]
        },
        {
          id: 6,
          colValue: '诚信自律',
          children: [
            {
              id: 61,
              colValue: '自律公约'
            },
            {
              id: 62,
              colValue: '诚信资讯'
            },
            {
              id: 63,
              colValue: '诚信法规'
            },
            {
              id: 64,
              colValue: '公约成员'
            }
          ]
        },
        {
          id: 10,
          colValue: '人才供需'
        },
        {
          id: 7,
          colValue: '关于协会',
          children: [
            {
              id: 71,
              colValue: '协会介绍'
            },
            {
              id: 72,
              colValue: '协会章程'
            },
            {
              id: 73,
              colValue: '业务范围'
            },
            {
              id: 74,
              colValue: '会员名单'
            },
            {
              id: 75,
              colValue: '联系我们'
            },
            {
              id: 76,
              colValue: '协会架构'
            },
            {
              id: 77,
              colValue: '专业委员会'
            },
            {
              id: 78,
              colValue: '入会邀请函'
            }
          ]
        }
      ],
      tTitle: '',
      total: 0,
      tabsData: [],
      targetArray: {},
      active: 0,
      type: null,
      parentType: null,
      page: {
        size: 10,
        total: 0,
        current: 1
      }
    };
  },
  created() {
    //获取栏目信息
    let tFilter = this.colData.filter(item => {
      return item.id === parseInt(this.$route.params.type);
    });

    this.targetArray = tFilter[0];

    //获取列表数据
    if (this.targetArray.children) {
      this.tTitle = this.targetArray.colValue;
      this.targetArray.children.forEach((item, index) => {
        this.tabsData[index] = item;
        this.tabsData[index].page = this.page;
      });
      if (this.$route.query.sType) {
        this.targetArray.children.forEach((item, index) => {
          if (item.id === parseInt(this.$route.query.sType)) {
            this.active = index;
          }
        });
        this.type = this.$route.query.sType;
        this.getList();
      } else {
        this.type = this.targetArray.children[0].id;
        this.getList();
      }
    } else {
      this.tabsData[0] = this.targetArray;
      this.tabsData[0].page = this.page;
      this.parentType = this.$route.params.type;
      this.getList();
    }
  },
  methods: {
    getList() {
      if (this.$route.query.current) {
        this.tabsData[this.active].page.current = this.$route.query.current;
      }
      if (this.$route.query.size) {
        this.tabsData[this.active].page.size = parseInt(this.$route.query.size);
      }
      this.$api(
        this.$config.apiUrl.frontList,
        {
          parentType: this.parentType,
          type: this.tabsData.length > 1 ? this.type : null,
          size: this.tabsData[this.active].page.size,
          current: this.tabsData[this.active].page.current
        },
        { method: 'get' }
      )
        .then(data => {
          let target = JSON.parse(JSON.stringify(this.tabsData));
          data.records.forEach(item => {
            item.createTime = moment(item.createTime).format('YYYY-MM-DD');
            if (item.publishTime) {
              item.publishTime = moment(item.publishTime).format('YYYY-MM-DD');
            }
          });
          target[this.active].page.total = data.total;
          target[this.active].page.current = data.current;
          target[this.active].newsList = data.records;

          this.tabsData = JSON.parse(JSON.stringify(target));
        })
        .catch(() => {
          console.log('失败');
        });
    },
    //切换栏目
    changeActive(val) {
      this.active = parseInt(val);
      this.type = this.tabsData[this.active].id;
      this.$router.replace({
        path: `/list/${this.$route.params.type}?sType=${this.type}&current=1&size=10`
      });
      this.getList(this.tabsData[this.active].id);
    },
    currentChange(val) {
      this.tabsData[this.active].page.current = val;
      if (this.tabsData.length > 1) {
        this.type = this.tabsData[this.active].id;
        this.$router.replace({
          path: `/list/${this.$route.params.type}?sType=${this.type}&current=${val}&size=${
            this.tabsData[this.active].page.size
          }`
        });
      } else {
        this.$router.replace({
          path: `/list/${this.$route.params.type}?current=${val}&size=${this.tabsData[this.active].page.size}`
        });
      }
      this.getList(this.tabsData[this.active].id);
    },
    handleSizeChange(val) {
      this.tabsData[this.active].page.size = val;
      this.tabsData[this.active].page.current = 1;
      if (this.tabsData.length > 1) {
        this.type = this.tabsData[this.active].id;
        this.$router.replace({
          path: `/list/${this.$route.params.type}?sType=${this.type}&current=${
            this.tabsData[this.active].page.current
          }&size=${val}`
        });
      } else {
        this.$router.replace({
          path: `/list/${this.$route.params.type}?&current=${this.tabsData[this.active].page.current}&size=${val}`
        });
      }
      this.getList(this.tabsData[this.active].id);
    }
  },
  components: {
    Header,
    NewsListTabs,
    Footer
  }
};
</script>

<style lang="less" scoped>
.container {
  min-width: 1198px;
  .dWrap {
    width: 1124px;
    padding: 0 14px;
    margin: 0 auto;
    background: #fff;
    overflow-x: hidden;
  }
  .content {
    padding: 30px 0 0px;
  }
}
</style>
